/**
 * @generated SignedSource<<d1358b2a3f1e1ea9ef429de036845b19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditLearnStartDateInput = {
  clientMutationId?: string | null;
  newStartDate: string;
  rootId: string;
  userId: string;
};
export type editLearnStartDateButton_EditLearnStartDateMutation$variables = {
  input: EditLearnStartDateInput;
};
export type editLearnStartDateButton_EditLearnStartDateMutation$data = {
  readonly Admin: {
    readonly LearnProgress: {
      readonly editLearnStartDate: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type editLearnStartDateButton_EditLearnStartDateMutation = {
  response: editLearnStartDateButton_EditLearnStartDateMutation$data;
  variables: editLearnStartDateButton_EditLearnStartDateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnProgressAdminMutationSchema",
        "kind": "LinkedField",
        "name": "LearnProgress",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "EditLearnStartDatePayload",
            "kind": "LinkedField",
            "name": "editLearnStartDate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "editLearnStartDateButton_EditLearnStartDateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "editLearnStartDateButton_EditLearnStartDateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c3af9a8a859eead9075bfaf990467881",
    "id": null,
    "metadata": {},
    "name": "editLearnStartDateButton_EditLearnStartDateMutation",
    "operationKind": "mutation",
    "text": "mutation editLearnStartDateButton_EditLearnStartDateMutation(\n  $input: EditLearnStartDateInput!\n) {\n  Admin {\n    LearnProgress {\n      editLearnStartDate(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa0b941f11a3a7c46755dc05f8d01022";

export default node;
